export default __webpack_public_path__ + "static/media/forward.dd0779c9.svg";